import { render, staticRenderFns } from "./FaqTrainingDatasetList.vue?vue&type=template&id=7c65139b&scoped=true&"
import script from "./FaqTrainingDatasetList.vue?vue&type=script&lang=js&"
export * from "./FaqTrainingDatasetList.vue?vue&type=script&lang=js&"
import style0 from "./FaqTrainingDatasetList.vue?vue&type=style&index=0&id=7c65139b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c65139b",
  null
  
)

export default component.exports